module.exports = __webpack_public_path__ + "img/gari.b7ab0332.png";